import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-216" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-4xl" data-id="element-217" data-mp="3ksgwy4rr2bbc">
        <div className="text-center" data-id="element-218" data-mp="3fyvxs9ef7bak">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-219" data-mp="3fxuly2pkykrs">
            Recensioni verificate
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-220" data-mp="36ypokzpr8xh7">
            Cosa dicono i tuoi{' '}
            <span className="italic text-grape" data-id="element-221" data-mp="31yl6j5977uov">colleghi</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-222" data-mp="2x1bh3plt7j11">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-cream p-6" data-id="element-223" data-mp="2s3t5frgeqppc">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-224" data-mp="q9u0roxsj6lm">
                <span aria-hidden="true" data-id="element-225" data-mp="h55aw37q1xxm">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-navy/85" data-id="element-226" data-mp="m5b3pmpq9qha">
                &laquo;{item.quote}&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-227" data-mp="c6ll1rq0c1zz">
                <p className="text-xs font-bold text-navy" data-id="element-228" data-mp="c7n0s9hyxco1">{item.name}</p>
                <p className="text-xs text-navy/45" data-id="element-229" data-mp="zw674jhgjfdh">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}